import React, {Component,Fragment} from "react";

import { connect } from "react-redux";
import { updateForm } from "../../../../store/actions/FormAction";

import { Grid, Row, Col } from 'react-bootstrap';
/*
    Dashboard view that displays the Dashboard pages
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class LoanSummary extends Component {
  constructor(props){
    super(props);
    this.withdrawn = this.withdrawn.bind(this);
  }

  withdrawn(e){
    e.preventDefault();
    this.props.updateForm("status", "Withdrawn");
  }

  render() {
    return (
      <Fragment>
        <p className="buttontitle">
          Loan Summary
        </p>
        <Grid className="loantabletitle" onClick={this.withdrawn}>
          <Row></Row>
          <Row>
            <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
              <strong>Loan  Principal</strong>
            </Col>
            <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
              <strong>Next Due Date</strong>
            </Col>
            <Col xs={4} className="text-center">
              <strong>Payment Due</strong>
            </Col>
          </Row>
          <Row>
            <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
              <p className="ptop nobottom">${this.props.principal}</p>
            </Col>
            <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
              <p className="ptop nobottom">{this.props.nextduedate}</p>
            </Col>
            <Col xs={4} className="text-center">
              <p className="ptop nobottom">${this.props.paymentamt}</p>
            </Col>
          </Row>
          <Row></Row>
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    principal: state.FormReducer.principal,
    nextduedate: state.FormReducer.nextduedate,
    paymentamt: state.FormReducer.paymentamt,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanSummary);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/LoanSummary.js